module.exports = __webpack_public_path__ + "static/media/chameleon-airlines-header.a6827840.png";